// extracted by mini-css-extract-plugin
export default {"photo":"ReorderablePhoto_photo__SHqFh","exitButton":"ReorderablePhoto_exitButton__DlsgE"};